import React from 'react'
// import PropTypes from 'prop-types'
import { Row, Col } from 'antd'
import PaginatedArticleList from 'components/shared/PaginatedArticles'
import SoftwareQuickLinks from 'components/category/SoftwareQuickLinks'
import RelatedCategories from 'components/category/RelatedCategories'

export default function CategoryFAQ({ category }) {
  const { articles, categoriesArticlesCount, softwares, relatedCategories } =
    category.attributes
  return (
    <Row
      className="page-wrapper page"
      gutter={[16, 16]}
      style={{ width: '100%', padding: '16px' }}
    >
      <Col xs={24} md={16}>
        <Row className="row-wrapper" style={{ width: '100%' }}>
          {articles.data.length > 0 ? (
            <PaginatedArticleList
              articles={articles.data}
              count={categoriesArticlesCount}
              type="category"
            />
          ) : (
            <h5> No FAQs Found </h5>
          )}
        </Row>
      </Col>
      <Col xs={24} md={8} style={{ marginTop: 16 }}>
        <RelatedCategories relatedCategories={relatedCategories} />
        <SoftwareQuickLinks softwares={softwares.data} />
      </Col>
    </Row>
  )
}

// CategoryFAQ.propTypes = {
//   category: PropTypes.shape({
//     name: PropTypes.string.isRequired,
//     articles: PropTypes.arrayOf(
//       PropTypes.shape({
//         title: PropTypes.string.isRequired,
//         slug: PropTypes.string.isRequired,
//         description: PropTypes.string.isRequired,
//       }).isRequired
//     ).isRequired,
//     categoriesArticlesCount: PropTypes.number.isRequired,
//   }).isRequired,
// }
